import React from "react";
import { Link, useLocation } from "react-router-dom";

const tabs = [
    { name: "Domestic Shipment", path: "/calculatorcourier" },
    { name: "Global Shipment", path: "/" },
];

const CalculateHeader = () => {
    const location = useLocation();

    return (
        <div className="bg-white rounded-lg">
            {/* Tabs */}
            <div className="mt-4 flex flex-wrap gap-2 border-b">
                {tabs.map((tab) => {
                    const isActive =
                        location.pathname === "/calculatorcourier"
                            ? tab.path === "/calculatorcourier"
                            : location.pathname.startsWith(tab.path);

                    const isDisabled = tab.name === "Global Shipment"; // Disable hover effect

                    return (
                        <Link
                            key={tab.name}
                            to={isDisabled ? "#" : tab.path} // Prevent navigation
                            className={`px-4 py-2 text-sm relative transition-all duration-200 ${isActive
                                ? "font-semibold text-black bg-slate-100 rounded-t-md after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-black"
                                : isDisabled
                                    ? "text-gray-400 cursor-not-allowed" // Disabled styles
                                    : "text-gray-600 hover:text-black"
                                }`}
                        >
                            {tab.name}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default CalculateHeader;
